import React from 'react';
import ReactDOM from 'react-dom';


class StopOn extends React.Component {
    constructor(props) {
        super(props);

        this.types = [
            {
                'key':'NewOrder',
                'description':'Customer placed an order',
            }
        ];

        this.renderOption = this.renderOption.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(e) {
        let key = e.target.getAttribute('data-key');
        let data = this.props.data.split(',');

        if (data.includes(key)) {
            data = data.filter(item => {
                return item == key ? false:true;
            });
        }else{
            data.push(key);
        }

        this.props.save(data.join(','))

    }

    renderOption(type) {
        return (
            <div className="list-group-item blue-grey-500" key={type.key}>
                <div style={{display:'inline-block',marginRight: '10px'}}  className="checkbox-custom checkbox-primary">
                    <input type="checkbox" id={'stop_followup_on_'+type.key} data-key={type.key} onChange={this.handleChange} checked={this.props.data.split(',').includes(type.key)} />
                    <label htmlFor={'stop_followup_on_'+type.key}>{type.description}</label>
                </div>
            </div>
        )
    }


    render() {
        return (
            <div>
                {
                    this.types.map(type => {
                       return this.renderOption(type);
                    })
                }
            </div>
        );
    }
}

export default StopOn;


// WEBPACK FOOTER //
// ./components/builder/StopOn.js